/**
 * TextSprite3DType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file TextSprite3DType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum TextSprite3DType {
  NEUTRAL = 0,
  HOSTILE = 1,
  FRIENDLY = 2,
  INFORMATION = 3,
}